var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { attrs: { id: "categories" } }, [
    _c("h2", { staticClass: "sr-only" }, [_vm._v("Icon Categories")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "categories-listing-featured margin-bottom-2xl" },
      [
        _c("h3", { staticClass: "sr-only" }, [_vm._v("Featured Categories")]),
        _vm._v(" "),
        _vm._l(_vm.featuredCategories, function (category, index) {
          return _c(
            "category-card",
            {
              key: `featured-${category.id}`,
              attrs: {
                category: category,
                "is-last": _vm.featuredCategories.length === index + 1,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "visuals padding-bottom-md",
                  attrs: { slot: "visuals" },
                  slot: "visuals",
                },
                _vm._l(category.visuals, function (icon) {
                  return _c("i", {
                    key: icon,
                    class: `fas fa-${icon} fa-fw size-2xl`,
                  })
                }),
                0
              ),
            ]
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "categories-listing" },
      [
        _c("h3", { staticClass: "sr-only" }, [_vm._v("All Categories")]),
        _vm._v(" "),
        _vm._l(_vm.categories, function (category, index) {
          return _c("category-card", {
            key: category.id,
            attrs: {
              category: category,
              "is-last": _vm.categories.length === index + 1,
            },
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }